import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '../../../../UI/button';
import GreenRedButtonBlock from '../../../../UI/green-red-button-block';
import BotTableRow from '../../../../UI/bot-table-row';
import AreUSureModal from '../../../../UI/are-u-sure-modal';

import style from '../provider-bot-page/provider-bot-page.module.scss';

const DepthBotView = ({
    botsData,
    areUSureModal,
    createNewBot,
    stopAllBots,
    cancelOrders,
    yesBtnAreUSureModal,
    switchAreUSureModal,
    switchStatusDepth,
    deleteDepthBot,
    editDepthBot,
    cannotChahgeBot,
    startAllBots,
    disabledStartAllBtn,
    goToPreview,
}) => {
    const { t } = useTranslation();

    return (
        <div className={style.botsWrapper}>
            <div className={style.botsWrapper__bot}>
                <p className={style.botsWrapper__bot_title}>
                    {t('aside.strategy')} / {t('aside.depthBots')} / {t('aside.bots')}
                </p>
                <div className={style.buttonsWrapper}>
                    <GreenRedButtonBlock
                        greenRedButtonWrapper={style.greenRedButtonWrapper}
                        botsData={botsData}
                        hideIfLessOne
                        clickGreenBtn={createNewBot}
                        clickRedBtn={stopAllBots}
                        greenBtnText={t('generals.createNew')}
                        redBtnText={t('generals.stopAll')}
                    />
                    <Button
                        onClick={startAllBots}
                        className={style.startAllBotsBtn}
                        type="button"
                        disabled={disabledStartAllBtn}
                    >
                        {t('generals.startAll')}
                    </Button>
                </div>
                <BotTableRow
                    isShowDailyVolume={false}
                    botsData={botsData}
                    switchStatusProvider={switchStatusDepth}
                    deleteBotHandler={deleteDepthBot}
                    editProviderBot={editDepthBot}
                    cannotChahgeBot={cannotChahgeBot}
                    cancelOrders={cancelOrders}
                    isCancelOrders
                    goToPreview={goToPreview}
                />
            </div>
            <AreUSureModal
                visibleModal={areUSureModal}
                noButton={switchAreUSureModal}
                yesButton={yesBtnAreUSureModal}
            />
        </div>
    );
};

DepthBotView.defaultProps = {
    botsData: [],
    areUSureModal: false,
    disabledStartAllBtn: false,
    startAllBots: () => {},
    stopAllBots: () => {},
    createNewBot: () => {},
    switchStatusDepth: () => {},
    deleteDepthBot: () => {},
    editDepthBot: () => {},
    yesBtnAreUSureModal: () => {},
    switchAreUSureModal: () => {},
    cannotChahgeBot: () => {},
    cancelOrders: () => {},
    goToPreview: () => {},
};

DepthBotView.propTypes = {
    botsData: PropTypes.arrayOf(PropTypes.object),
    areUSureModal: PropTypes.bool,
    disabledStartAllBtn: PropTypes.bool,
    startAllBots: PropTypes.func,
    stopAllBots: PropTypes.func,
    createNewBot: PropTypes.func,
    switchStatusDepth: PropTypes.func,
    deleteDepthBot: PropTypes.func,
    editDepthBot: PropTypes.func,
    yesBtnAreUSureModal: PropTypes.func,
    switchAreUSureModal: PropTypes.func,
    cannotChahgeBot: PropTypes.func,
    cancelOrders: PropTypes.func,
    goToPreview: PropTypes.func,
};

export default DepthBotView;
